// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Video-module--cds--assistive-text--483be";
export var cdsHideFeedback = "Video-module--cds--hide-feedback--50ea6";
export var cdsShowFeedback = "Video-module--cds--show-feedback--5251a";
export var cdsSkeleton = "Video-module--cds--skeleton--43b25";
export var cdsVisuallyHidden = "Video-module--cds--visually-hidden--7ad50";
export var video = "Video-module--video--483a5";
export var videoButton = "Video-module--video-button--982ec";
export var videoContainer = "Video-module--video-container--b0cda";
export var videoIsPlaying = "Video-module--video--is-playing--3bd64";
export var vimeo = "Video-module--vimeo--febb9";